document.addEventListener('DOMContentLoaded', () => {
  const PERSISTENT_FILTER_KEY = 'persistentCollectionFilter';
  const DEFAULT_FILTER = 't-shirt';
  const EXCLUDED_PATHS = [
    '/collections/pack-builder',
    '/collections/graphic-bundles'
  ];
  /**
   * Checks the current URL path for a collection filter tag.
   * e.g., /collections/all/t-shirt -> returns "t-shirt"
   */
  function getActiveFilterFromUrl() {
    const filterRegex = /^\/collections\/[^/]+\/(.+)/;
    const match = window.location.pathname.match(filterRegex);
    return match ? match[1] : null;
  }

  /**
   * Appends the sticky filter to any simple collection links on the page.
   */
  function updateCollectionLinks(filter) {
    if (!filter) return;

    document.querySelectorAll('a[href*="/collections/"]').forEach(link => {
      try {
        const url = new URL(link.href, window.location.origin);
        
        // Exclude specific collection paths
        if (EXCLUDED_PATHS.includes(url.pathname)) {
          return;
        }

        // Check if the link is a plain collection URL without any filters/tags.
        const isSimpleCollectionLink = /^\/collections\/[^/]+$/.test(url.pathname);

        if (isSimpleCollectionLink) {
          url.pathname = `${url.pathname}/${filter}`;
          link.href = url.href;
        }
      } catch (e) {
        // Ignore invalid URLs
      }
    });
  }

  /**
   * Initializes the filter logic on page load.
   */
  function initPersistentFilters() {
    const isCollectionPage = /^\/collections\/[^/]+/.test(window.location.pathname);
    const currentUrlFilter = getActiveFilterFromUrl();

    if (isCollectionPage) {
      if (currentUrlFilter) {
        // On a filtered page, save the filter.
        sessionStorage.setItem(PERSISTENT_FILTER_KEY, currentUrlFilter);
      } else {
        // On an unfiltered collection page, clear any saved filter, allowing it to fall back to default.
        sessionStorage.removeItem(PERSISTENT_FILTER_KEY);
      }
    }

    // Determine which filter to apply to the links.
    let filterToApply = sessionStorage.getItem(PERSISTENT_FILTER_KEY);

    // If no filter is stored in memory, use the default.
    if (!filterToApply) {
      filterToApply = DEFAULT_FILTER;
    }

    // Update links on the current page with the determined filter.
    updateCollectionLinks(filterToApply);
  }

  // Run the main function.
  initPersistentFilters();

  // For modern themes that load content with AJAX, we use a MutationObserver
  // to re-apply filters when new links are added to the page.
  const observer = new MutationObserver(() => {
    let storedFilter = sessionStorage.getItem(PERSISTENT_FILTER_KEY);
    
    // If no filter is stored, default to 't-shirt'.
    if (!storedFilter) {
      storedFilter = DEFAULT_FILTER;
    }

    updateCollectionLinks(storedFilter);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});